import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import clsx from "clsx";

import one from "../../assets/Order/one.svg";
import two from "../../assets/Order/two.svg";
import three from "../../assets/Order/three.svg";
import myGinne_sales from "../../assets/Order/myGinneSales.svg";
import store_sales from "../../assets/Order/store_sales.svg";
import total_revenue from "../../assets/Order/total_revenue.svg";
import total_amount from "../../assets/Order/total_amount.svg";
import LoadingSpinner from "../Loading";
import SelectBox from "../CustomWidgets/SelectBox";
import arrowright from "../../assets/arrowright.svg";

import moment from "moment";

import { DatePicker, Space } from "antd";
import {
  getEorderDashboard,
  getEorderDashboardLahloob,
} from "../../API  Functions/Eorders";
import { getPurchaseDashData } from "../../API  Functions/DashboardFunctions";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

const formatDate = (date) => dayjs(date).format("YYYY-MM-DD");

const getStartOfWeek = () => {
  const today = new Date();
  const dayOfWeek = today.getDay(); // 0 is Sunday, 1 is Monday, ..., 6 is Saturday
  const startOfWeek = new Date(today);
  startOfWeek.setDate(today.getDate() - dayOfWeek);
  return startOfWeek.toISOString().split("T")[0];
};

const getStartOfMonth = () => {
  const today = new Date();
  const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

  // Format the date as 'YYYY-MM-DD' without using toISOString to avoid timezone issues
  const year = startOfMonth.getFullYear();
  const month = String(startOfMonth.getMonth() + 1).padStart(2, "0"); // Ensure month is two digits
  const day = String(startOfMonth.getDate()).padStart(2, "0"); // Ensure day is two digits

  return `${year}-${month}-${day}`;
};

const PurchaseDash = () => {
  const navigate = useNavigate();

  const { t, i18n } = useTranslation();
  const is_lahloob = useSelector(
    (state) => state.login?.user?.result?.is_lahloob
  );
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id
  );

  const [loading, setLoading] = useState(false);
  const [mgiData, setMgiData] = useState();

  useEffect(() => {
    if (user_id) {
      getKPI();
    }
  }, [user_id]);

  const getKPI = async () => {
    try {
      const res1 = await getPurchaseDashData(user_id);
      // console.log("Purchase ------>API data: ", res1);
      const kpiData = res1?.result;
      // console.log("Purchase API data: ", kpiData);
      setMgiData(kpiData);
    } catch (error) {
      console.error("Error fetching KPI data:", error);
    }
  };

  //   const handleDateRangeChange = (range) => {
  //     let CurrentSelection = range.target.value;
  //     // console.log("CurrentSelection", CurrentSelection);

  //     setSelectedRange(range.target.value); // Update selected range state
  //     const currentDate = new Date(); // Use native Date
  //     let startDate, endDate;

  //     if (CurrentSelection === "today") {
  //       startDate = getCurrentDate();
  //       endDate = getCurrentDate();
  //     } else if (CurrentSelection === "thisWeek") {
  //       startDate = getStartOfWeek();
  //       endDate = getCurrentDate();
  //     } else if (CurrentSelection === "thisMonth") {
  //       startDate = getStartOfMonth();
  //       endDate = getCurrentDate();
  //     } else if (CurrentSelection === "custom") {
  //       return;
  //     }
  //     Promise.all([
  //       getEorderDashboard(user_id, startDate, endDate, is_lahloob),
  //     //   getEorderDashboardLahloob(company_id, startDate, endDate),
  //     ])
  //       .then(([dashboardDataRes]) => {
  //         const kpiData = dashboardDataRes?.result?.[0]?.response;
  //         setMgiData(kpiData);

  //         // const lahloobData = lahloobDataRes?.result?.data;
  //         // setLahloobData(lahloobData);
  //       })
  //       .catch((err) => {
  //         console.error("Error fetching KPIs:", err);
  //       });
  //   };

  //   const handleRangePickerChange = (dates) => {
  //     if (dates) {
  //       const startDate = formatDate(dates[0]);
  //       const endDate = formatDate(dates[1]);
  //       Promise.all([
  //         getEorderDashboard(user_id, startDate, endDate, is_lahloob),
  //         // getEorderDashboardLahloob(user_id, startDate, endDate),
  //       ])
  //         .then(([dashboardDataRes]) => {
  //           const kpiData = dashboardDataRes?.result?.[0]?.response;
  //           setMgiData(kpiData);

  //         //   const lahloobData = lahloobDataRes?.result?.data;
  //         //   setLahloobData(lahloobData);
  //         })
  //         .catch((err) => {
  //           console.error("Error fetching KPIs:", err);
  //         });
  //     }
  //   };

  //   const disabledDate = (current) => {
  //     return current && current > moment().endOf("day");
  //   };

  const formatCurrency = (amount) =>
    `${t("EGP")} ${amount?.toFixed(2) || "0.00"}`;

  const baseCardProps = {
    bgcolor: "#EAF8FD",
    textcolor: "text-gray-700",
  };

  const values = {
    1: {
      img: total_amount,
      heading: t("Purchase List"),
      productsleft: formatCurrency(mgiData?.total_bill_amount),
      action: () => navigate("/purchase/list"),
      ...baseCardProps,
    },
    2: {
      img: myGinne_sales,
      heading: t("No. Of Draft Orders"),
      productsleft: mgiData?.draft_orders_count,
      ...baseCardProps,
    },
    3: {
      img: three,
      heading: t("View Vendor Payment"),
      // productsleft: (
      //   //    `${t("Total no. of orders")} | ${
      //   //     lahloobData?.total_orders ?? 0
      //   //   }, ${t("No. of new orders")} ${lahloobData?.new_orders ?? 0}`,
      //   <>
      //     <div className="text-lg font-semibold">
      //       <span className="">{t("No Of Orders")}</span>
      //       <span className="ms-2 me-2">{mgiData?.done_orders_count ?? 0}</span>
      //       {"|"}
      //       <span className="ms-2">
      //         {t("No. Of Pending Orders")}
      //         <span className="ms-2">{mgiData?.pending_bill_count ?? 0}</span>
      //       </span>
      //     </div>
      //   </>
      // ),
      productsleft: (
        <div className="text-lg font-semibold">
          <span>{t("No. Of Orders")}</span>
          <span className="ms-2 me-2">{mgiData?.done_orders_count ?? 0}</span>
          <span className="me-2">|</span>
          <span>{t("No. Of Pending Orders")}</span>
          <span className="ms-2">{mgiData?.pending_bill_count ?? 0}</span>
        </div>
      ),
      bgcolor: "#EAF8FD",
      textcolor: "#0F172A",
      showArrow: true,
      wide: true,
      action: () => navigate("/purchase/supplyPayment"), // customize route
    },
  };

  const tileValues = values;

  return (
    <>
      {loading && <LoadingSpinner />}
      <div className="bg-white mt-5 rounded-xl shadow-sm p-6">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6">
          <h3 className="text-2xl font-semibold text-gray-800">
            {t("Purchase")}
          </h3>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 xl:grid-cols-4  ">
          {Object.values(tileValues).map((val, index) => (
            <div
              key={index}
              className={`rounded-2xl p-4 shadow-md transition-transform transform hover:scale-[1.02] hover:shadow-lg cursor-pointer ${
                val.wide ? "col-span-2" : ""
              }`}
              style={{ backgroundColor: val.bgcolor }}
              onClick={val.action}
            >
              <div className="flex items-center justify-between gap-3">
                <div className="flex items-center gap-3">
                  <img src={val.img} alt="icon" className="w-10 h-10" />
                  <div className="flex flex-col">
                    <p className="text-base font-medium text-gray-700 truncate">
                      {val.heading}
                    </p>
                    <p
                      className="text-xl font-bold"
                      style={{ color: val.textcolor }}
                    >
                      {val.productsleft}
                    </p>
                  </div>
                </div>
                {val.showArrow && (
                  <img
                    src={arrowright}
                    className={`ms-2 ${
                      i18n.language === "en" ? "" : "rotate-180"
                    }`}
                    alt="arrowright"
                    width={20}
                    height={20}
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
export default PurchaseDash;
